// require('./bootstrap');

// 顔検出はサーバ側(/vision/face)で行う。Google Vision の APIキーはサーバの env に保持し、
// クライアント(このバンドル)には一切含めない。レスポンスは { faces: <顔の数> }。
// 画像プレビュー(#figureImage)の表示は app.js 側の #upload_photo ハンドラが担当する。
(function () {
  const endpoint = '/vision/face';

  const input = document.querySelector('#upload_photo');
  if (!input) return;

  const button = document.querySelector('#upload_button');
  const figure = document.querySelector('#figure');
  const uploadSubmit = document.querySelector('#js-submit');
  const status = document.querySelector('pre');

  // CSRFトークンは head の meta を優先し、フォームの _token をフォールバックにする
  const csrfToken = () => {
    const meta = document.querySelector('meta[name="csrf-token"]');
    if (meta && meta.getAttribute('content')) return meta.getAttribute('content');
    const field = document.querySelector('input[name="_token"]');
    return field ? field.value : '';
  };

  // サーバ側の顔検出APIへ送信
  const detectFaces = (file) => {
    const form = new FormData();
    form.append('photo', file);
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': csrfToken(),
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: form,
    }).then((res) => {
      if (!res.ok) throw new Error('request failed: ' + res.status);
      return res.json();
    });
  };

  input.addEventListener('change', (ev) => {
    if (!ev.target.files || ev.target.files.length === 0) return;
    const file = ev.target.files[0];
    const sizeLimit = 1024 * 1024 * 5; // 制限サイズ 5MB
    if (file.size > sizeLimit) {
      alert('ファイルサイズは5MB以下にしてください');
      ev.target.value = '';
      return;
    }

    status.innerHTML = '審査中...';
    uploadSubmit.disabled = true;

    detectFaces(file)
      .then((data) => {
        const faces = data && typeof data.faces === 'number' ? data.faces : 0;
        if (faces > 1) {
          figure.style.display = 'none';
          button.style.display = 'block';
          status.innerHTML = '顔が複数検出されました。1人の写真を登録し直してください。';
        } else if (faces === 0) {
          figure.style.display = 'none';
          button.style.display = 'block';
          status.innerHTML = '顔が検出されませんでした。別の写真を登録し直してください。';
        } else {
          status.innerHTML = '顔が検出されました。';
          uploadSubmit.disabled = false;
        }
      })
      .catch((err) => {
        console.log('FAILED:(', err);
        status.innerHTML = '画像の解析に失敗しました。';
      });
  });
})();
